import React, { useEffect, useState } from 'react';
import styled, { keyframes } from 'styled-components';
import CircleChart from './CircleChart';
import CPLoading from './CPLoading';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useDispatch, useSelector } from 'react-redux';
import { addCompData } from '../Redux/projectsSlice';
import { base, deepClone, deltaT } from '../utils';

// Define the CompetitionProject component
const CompetitionProject = ({ listn }) => {
  const [data, setData] = useState([])
  const [updatedData, setUpdatedData] = useState([])
  // const [urls, setUrls] = useState(['moz.com', 'overwatch.blizzard.com', 'blizzard.com'])
  const [project, setProject] = useState(null)


  const pName = window.location.href.split('=').pop().trim().replaceAll('%20', ' ')

  const user = useSelector(state=> state.user.user)
  const projects = useSelector(state=> state.projects.projects)

  const dispatch = useDispatch()

  useEffect(()=> {
    if(projects) {
      let p
      
      projects.map(proj => {
        if(proj.name.toLowerCase() === pName && proj.type === 'competition') {
          p = proj
          return
        }
      })
      setProject(p)
    }
  }, [projects])


  

  const getData = async () => {
    if(project) {
        fetch(`${base}/res`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            type: 'cp-',
            urls: project.urls,
            userId: user.id
          })
        }).then(res=> res.json()).then(data=> {
          setData([data])
          setUpdatedData([data])
        })
      }
  }



  useEffect(()=> {
    if(project && (project?.data?.length === 0 || !deltaT(project?.lastUpdated, 3) || project?.data[0].error)) {
        getData()
    } else if(project) {
      setData(project.data)
    }

  }, [project])


  useEffect(()=> {
    if(updatedData.length !== 0) {
        let updatedProject = deepClone(project)
        updatedProject.data = data
        updatedProject.lastUpdated = new Date().toUTCString()
   
        dispatch(addCompData({pName: pName, updatedProject: updatedProject}))
        listn()
    }
  }, [updatedData, data])




  return (
    <Container>
      {data?.length !== 0 && <SettingsContainer>
          <div className='upper-section'>
            <h1>{pName}</h1>
            <p><span style={{color: '#b3b3b3'}}>Last updated on</span> {project?.lastUpdated} <p style={{color: 'dodgerblue', marginTop: '2px', fontSize: 'small'}}>The next update is scheduled 3 days after the last one</p>
            <p style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px', width: '360px', wordWrap: 'break-word', marginTop: '20px', fontSize: 'small'}}><ReportProblemIcon /> <p>Our Competition Project is in Beta Mode—new insights and optimizations are on the way, but it may not work perfectly yet!</p></p></p>
          </div>
          <div className='comp_yourUrl'>
          <div className='urls'>
            <p style={{color: '#b3b3b3', marginBlock: '5px'}}>Targeted competitors</p>
            {project?.urls?.map(url=> {
              return (
                <p key={url}>{url}</p>
              )
            })}
          </div>
          <div className='urls'>
            <p style={{color: '#b3b3b3', marginBlock: '5px'}}></p>
            <p></p>
          </div>
          </div>
      </SettingsContainer>}
      {data[0]?.meta?.map((entry, index) => {
        let chartData = data[0].density.find(yObject => yObject.url === entry.url)
        let linksData = data[0].links.find(yObject => yObject.url === entry.url)
        let daData = data[0].daData.find(yObject => yObject.url === entry.url)
        let paData = data[0].paData.find(yObject => yObject.url === entry.url)
      return (
        <CompetitorContainer key={index}>
          <CompetitorData>
            <h3>{entry.url}</h3>
            <MetaData>
              <h4>Meta Description</h4>
              <div><h5>Title:</h5> <span>{entry.data[0].content}</span></div>
              <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}><h5>Description:</h5> <span className='dis_block'>{entry.data[2]?.content}</span></div>
            </MetaData>
            <Backlinks>
            <h4>Backlinks</h4>
                  <div style={{display: 'flex', flexDirection: 'column', gap: '20px', marginTop: '30px'}}>
                    <div><p>Total links:</p><span style={{color: 'gray', fontSize: 'small', width: '50px'}}> {linksData?.data.info.backlinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                    <div><p>Home page backlinks: </p><span style={{color: 'gray', fontSize: 'small', width: '50px'}}>{linksData?.data.info.hpLinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                    <div><p>Unique backlinks:</p> <span style={{color: 'gray', fontSize: 'small', width: '50px'}}>{linksData?.data.info.uniqueBacklinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                    <div><p>Dofollow backlinks:</p> <span style={{color: 'gray', fontSize: 'small', width: '50px'}}>{(Number(linksData?.data.info.backlinks) - Number(linksData?.data.info.uniqueBacklinks)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                    <div><p>Nofollow backlinks:</p> <span style={{color: 'gray', fontSize: 'small', width: '50px'}}>{linksData?.data.info.nofollowBacklinks.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span></div>
                  </div>
            </Backlinks>
          </CompetitorData>
          <VerticalLine />
          <CompetitorData>
            <Chart>
              <h4>Top Ten Keywords Utilized by This Competitor with Weight Distribution</h4>
              <CircleChart data={chartData.density.slice(0, 10)} />
            </Chart>

            <DAPAData>
              <div>
                <p>Domain Authority:  <span style={{color: '#8884d8'}}>{daData?.da}%</span></p>
                <p>Page Authority:  <span style={{color: '#8884d8'}}>{paData?.pa}%</span></p>
              </div>
            </DAPAData>
          </CompetitorData>
        </CompetitorContainer>
        
      )})}
      <div style={{marginBlock: '60px'}}></div>
      {data.length === 0 && <CPLoading />}
    </Container>
  );
};

// Define styled components
const Container = styled.div`
  background-color: #f2f2f2;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: auto;
  height: 100%;
`;


const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;

  > .upper-section {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  > .upper-section > h1 {
    color: #8884d8;
    font-weight: 300;
  }

  > .upper-section > p {
    color: #8884d8;
    margin-left: auto;
  }

  > .comp_yourUrl {
    display: flex;
    flex-direction: row;
    gap: 100px;
  }


  > .comp_yourUrl > .urls {
    margin-top: 20px;
  }

  > .comp_yourUrl > .urls > p {
    color: #8884d8;
  }
`


const typingAnimation = keyframes`
  from { width: 0 }
  to { width: 100% }
`;

const CompetitorContainer = styled.div`
  display: flex;
  border: 1px solid #ccc;
  border-radius: 8px;
  margin-bottom: 20px;
  background-color: white;
  margin: 15px;
  padding: 10px;
`;

const CompetitorData = styled.div`
  flex: 1;
  padding: 20px;
  
  > h3 {
    color: #8884d8;
    font-weight: 300;
    animation: ${typingAnimation} 2s steps(40, end);
  }
`;

const MetaData = styled.div`
  margin-block: 55px;

  > h4 {
    margin-bottom: 10px;
    font-weight: 300;
    animation: ${typingAnimation} 2s steps(40, end);
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  > div > h5 {
    width: 100px;
    animation: ${typingAnimation} 2s steps(40, end);
  }

  > div > span {
    margin: 10px;
    color: #8884d8;
    animation: ${typingAnimation} 2s steps(40, end);
  }
`;

const Chart = styled.div`
  margin-bottom: 20px;

  > h4 {
    margin-bottom: 10px;
    font-weight: 300;
    animation: ${typingAnimation} 2s steps(40, end);
  }

  > div > p {
    color: #8884d8;
    animation: ${typingAnimation} 2s steps(40, end);
  }
`;

const Backlinks = styled.div`
  margin-block: 55px;

> h4 {
    margin-bottom: 10px;
    font-weight: 300;
    animation: ${typingAnimation} 2s steps(40, end);
  }

  > div > div {
    display: flex;
    flex-direction: row;
    color: #8884d8;
  }

  > div > div > p {
    width: 200px;
    animation: ${typingAnimation} 2s steps(40, end);
  }

  > div > div > span {
    margin-left: 30px;
    animation: ${typingAnimation} 2s steps(40, end);
  }
`;

const DAPAData = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 70px;

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  > div > p {
    width: 260px;
  }
`

const VerticalLine = styled.div`
  border-left: 1px solid #ccc;
`;

export default CompetitionProject;
